import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import { ClientStateService } from './client-state.service.js';
import { Observable } from 'rxjs';

@Injectable()
export class AdminAuthInterceptor implements HttpInterceptor {
    constructor(private clientState: ClientStateService) {}

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!request.headers.get('authorization')) {
            request = request.clone({
                setHeaders: this.clientState.authHeaders()
            });
        }
        return next.handle(request);
    }
}
